/* eslint-disable import/no-named-as-default-member */
import { getDataSourceWithInjection } from '@bingads-webui-campaign/campaigns-data';
import _ from 'underscore';
/* eslint-disable import/extensions */

/* eslint-disable import/no-unresolved */
import legacyPreferenceService from '@bingads-webui-component-legacy/preference/service/index';
import instrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import { getColumnsMap, getBaseColumnsByType } from '@bingads-webui-campaign-legacy/campaigns-tab-campaigns/grid/columns-config-base';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import edm from '@bingads-webui-component-legacy/edm-campaign/index';
import * as ColumnChooserPreference from '@bingads-webui-component-legacy/bingads-grid/service/column-chooser-preferences';
import * as customColumnPreference from '@bingads-webui-component-legacy/bingads-grid/service/custom-column-preferences';
import * as SegmentationPreference from '@bingads-webui-component-legacy/bingads-grid/service/segmentation-preferences';
import * as fetchPagination from '@bingads-webui-component-legacy/bingads-grid/service/fetch-pagination';
import dateUtil from '@bingads-webui-component-legacy/humanize/date';
import state from '@bingads-webui-component-legacy/state/index';
import { fetchSortInfo } from '@bingads-webui-component-legacy/bingads-grid/service/fetch-sortinfo';
import logger from '@bingads-webui-static-legacy/instrumentation/index';
import appConfig from '@bingads-webui-component-legacy/config/index';
import sessionStore from '@bingads-webui-component-legacy/js-data-storage/session-storage';
import { getFilters } from '@bingads-webui-component-legacy/bingads-grid/service/filter-preferences';
import cacheService from '@bingads-webui-static-legacy/cache-service';
import dataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';

export function fetchDataForCampaigns({
  serverContext,
  preferenceService,
  newI18n,
  resolve,
}) {
  const scope = {
    values: {
      uid: serverContext.CurrentUser.Id,
      cid: serverContext.CurrentCustomer.Id,
      aid: serverContext.CurrentAccount.Id,
    },
  };

  instrumentation.addScenario({
    scenario: [
      {
        name: 'campaignGridDataPrefetch',
        value: 'CampaignGridDataPrefetch',
        activity: [
          {
            name: 'dataQueryBuilder',
            value: 'DataQueryBuilder',
          },
        ],
      },
    ],
  });

  const logActivity = instrumentation.campaignGridDataPrefetch
    .create()
    .dataQueryBuilder
    .create();

  // Seems this i18n isn't used anyways
  const stub = () => '';
  const stubI18n = {
    parseInt: stub,
    get: stub,
    getString: stub,
    type: stub,
    property: stub,
    value: stub,
    enum: stub,
    // deprecated
    enumMappedString: stub,
    valueDescription: stub,
    enumDescription: stub,
  };

  if (serverContext.Permissions.IsOptimizationScoreInCampaignsGridEnabled === true) {
    legacyPreferenceService.initialize();
    let optimizationScoreInCampaignsGridDefaultOn = legacyPreferenceService.findByName('OptimizationScoreInCampaignsGridDefaultOn');
    if (!optimizationScoreInCampaignsGridDefaultOn || !optimizationScoreInCampaignsGridDefaultOn.Data || !optimizationScoreInCampaignsGridDefaultOn.Data.appended2Column) {
      optimizationScoreInCampaignsGridDefaultOn = {
        Name: 'OptimizationScoreInCampaignsGridDefaultOn',
        Data: { appended2Column: true },
      };
      preferenceService.setAtAccountLevel(optimizationScoreInCampaignsGridDefaultOn);
      const campaignsGridCustomColumn = legacyPreferenceService.findByName('WebApp.CampaignUI.Columns.summary_tab_campaign.Custom');
      if (campaignsGridCustomColumn && _.indexOf(campaignsGridCustomColumn.Data, 'OptimizationScore') === -1) {
        let index = _.indexOf(campaignsGridCustomColumn.Data, 'DeliveryStatus');
        if (index === -1) index = _.indexOf(campaignsGridCustomColumn.Data, 'Budget');
        if (index === -1) index = _.indexOf(campaignsGridCustomColumn.Data, 'Name');
        if (index !== -1) {
          campaignsGridCustomColumn.Data.splice(index + 1, 0, 'OptimizationScore');
          legacyPreferenceService.setAtAccountLevel(campaignsGridCustomColumn);
        }
      }
    }
  }

  const dataSourceWithInjection = getDataSourceWithInjection({
    gridName: null,
    logActivity,
    preferenceService,
    newI18n,
    serverContext,
    jsData,
    edm,
    ColumnChooserPreference,
    customColumnPreference,
    SegmentationPreference,
    fetchPagination,
    dateUtil,
    state,
    fetchSortInfo,
    getColumnsMap,
    getBaseColumnsByType,
    logger,
    appConfig,
    i18n: stubI18n,
    sessionStore,
    preferenceStoreFactory: getFilters,
    legacyGlobalI18n: stubI18n,
    schemaI18nCampaign: stubI18n,
    cacheService,
    dataContextManager,
    scope,
  });

  const { CampaignFilterImprovementEnabled } = serverContext.DynamicPermissions;
  const dataSource = CampaignFilterImprovementEnabled ? dataSourceWithInjection.dataSource : dataSourceWithInjection;
  const p$dfm = dataSource.query({}, {}, resolve, true);

  return { dataSource, p$dfm };
}
